import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=73640fc1&scoped=true&"
import script from "./InputText.vue?vue&type=script&lang=js&"
export * from "./InputText.vue?vue&type=script&lang=js&"
import style0 from "./InputText.vue?vue&type=style&index=0&id=73640fc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73640fc1",
  null
  
)

export default component.exports